import React from 'react'
import { Video } from '@shared/components/video'
import cn from 'classnames'

import { Back } from '../Back'

import styles from './styles.module.scss'

const LoanConditions = () => {
	return (
		<article className={styles.article}>
			<Back />
			<h1 className={styles.heading}>Условия получения кредита</h1>
			<nav className={styles.nav}>
				<ul>
					<li className={styles.title}>Про заёмщика</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#primary-requirements'>
							Какие основные требования к заёмщикам?
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#take-money-with-bad-credit-history'>
							Возможно ли получить кредит, если были просрочки и плохая кредитная история?
						</a>
					</li>
					<li className={cn(styles.navItem, styles.lastItem)}>
						<a className={styles.link} href='#take-money-without-official-income'>
							Нет официального дохода. Сможете рассмотреть заявку?
						</a>
					</li>
					<li className={styles.title}>О залогодателе</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#who-pledger'>
							Кто может быть залогодателем?
						</a>
					</li>
					<li className={cn(styles.navItem, styles.lastItem)}>
						<a className={styles.link} href='#pledger-verification'>
							Залогодатель проходит проверку так же, как и заёмщик?
						</a>
					</li>
					<li className={styles.title}>Про недвижимость</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#requirements-for-pledge'>
							Какие квартиры подходят для залога?
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#flat-pledge'>
							Квартира остаётся в собственности залогодателя. Что с ней происходит после оформления
							сделки?
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#renter-and-pledge'>
							Нужно ли выселять арендаторов из квартиры, чтобы получить кредит?
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#sell-pledged-flat'>
							Как продать квартиру, которая находится в залоге?
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#loan-and-share-of-real-estate'>
							Можно ли взять кредит под залог доли?
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#pledged-real-estate'>
							Можно ли взять кредит, если недвижимость уже в залоге?
						</a>
					</li>
					<li className={cn(styles.navItem, styles.lastItem)}>
						<a className={styles.link} href='#take-money-without-pledge'>
							Нет квартиры в собственности для залога. Что делать, если нужны деньги?
						</a>
					</li>
					<li className={styles.title}>Подача заявки</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#documents'>
							Какие документы нужны для подачи заявки?
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#check'>
							Сколько проверяется заявка?
						</a>
					</li>
					<li className={cn(styles.navItem, styles.lastItem)}>
						<a className={styles.link} href='#decision'>
							Как узнать решение по заявке?
						</a>
					</li>
				</ul>
			</nav>

			<h3 id='loaner' className={styles.title}>
				Про заёмщика
			</h3>
			<h3 className={styles.bold}>Какие основные требования к заёмщикам?</h3>
			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
				Получить деньги через Credit.Club могут клиенты:{' '}
			</p>
			<ul className={styles.list}>
				<li className={styles.item}>— ИП, юридические и физические лица;</li>
				<li className={styles.item}>— граждане РФ — для займов частным лицам;</li>
				<li className={styles.item}>— граждане РФ и нерезиденты РФ — для займов бизнесу;</li>
				<li className={styles.item}>
					— в возрасте от 20 до 70 лет на момент окончания договора кредитования.
				</li>
			</ul>
			<h3 id='take-money-with-bad-credit-history' className={styles.bold}>
				Возможно ли получить кредит, если были просрочки и плохая кредитная история?
			</h3>

			<p className={styles.paragraph}>
				Мы лояльно относимся к кредитной истории. Если у клиента когда-то были просрочки, это вряд
				ли станет стоп-фактором при рассмотрении заявки. Мы изучаем множество показателей и
				составляем совокупный отчёт, по которому выносим решение.
			</p>
			<p className={styles.paragraph}>
				Наша тактика рассмотрения заявок отличается от банковской: стараемся находить индивидуальный
				подход к каждому клиенту. Иногда можем глубже проанализировать ситуацию или выйти на
				переговоры, чтобы уточнить детали.
			</p>

			<p className={styles.paragraph}>Подробности можете изучить в ролике:</p>
			<p className={styles.paragraph}>
				{/* 6 способов улучшить кредитную историю */}
				<Video
					poster='/images/webp/history-improvement.webp'
					src='/videos/history-improvement.mp4'
				/>
			</p>

			<h3 id='take-money-without-official-income' className={styles.bold}>
				Нет официального дохода. Сможете рассмотреть заявку?
			</h3>

			<p className={styles.paragraph}>
				Мы лояльны к клиентам без официального дохода. При оценке заявки смотрим на благосостояние
				человека, анализируя множество других факторов.
			</p>

			<h3 className={styles.title}>О залогодателе</h3>
			<h3 id='who-pledger' className={styles.bold}>
				Кто может быть залогодателем?
			</h3>

			<p className={styles.paragraph}>
				Залогодатель — человек, который готов предоставить залог для обеспечения кредита. Им может
				сам заёмщик, либо любое третье лицо. Требования к залогодателю практически такие же, что и к
				заёмщику. Разница в том, что залогодателем может быть иностранный гражданин.
			</p>

			<h3 id='pledger-verification' className={styles.bold}>
				Залогодатель проходит проверку так же, как и заёмщик?
			</h3>

			<p className={styles.paragraph}>
				Если залогодатель — третье лицо, то мы проверяем его так же тщательно, как и заёмщика. У нас
				единые правила для всех участников сделки.
			</p>

			<h3 id='facility' className={styles.title}>
				Про недвижимость
			</h3>

			<h3 id='requirements-for-pledge' className={styles.bold}>
				Какие квартиры подходят для залога?
			</h3>

			<p className={styles.paragraph}>
				Важно, чтобы квартира соответствовала двум основным параметрам:
			</p>
			<ol className={styles.orderedList}>
				<li className={styles.orderedItem}>Нет несовершеннолетних собственников.</li>
				<li className={styles.orderedItem}>
					Объект для залога расположен в крупном городе или его пределах.
				</li>
			</ol>

			<p className={styles.paragraph}>
				Мы рассматриваем каждую заявку индивидуально: можем оформить кредит под залог
				многоквартирного дома любого возраста, недвижимости внутри объекта культурного наследия или
				даже квартиры, где один из собственников является гражданином другой страны.
			</p>

			<h3 id='flat-pledge' className={styles.bold}>
				Квартира остаётся в собственности залогодателя. Что с ней происходит после оформления
				сделки?
			</h3>
			<p className={styles.paragraph}>
				Мы работаем в соответствии с законом 102-ФЗ «Об ипотеке». Поэтому после оформления сделки на
				недвижимость накладывается обременение. То есть квартира остаётся в собственности заёмщика,
				но на неё начинают действовать ограничения на продажу, обмен или дарение. При этом если
				получить согласие у кредитора, ограничения можно снять.
			</p>

			<p className={styles.paragraph}>
				Подчеркнём: мы не переоформляем квартиры на третьих лиц, не выкупаем их и не выписываем
				владельцев. Заёмщик остаётся владельцем недвижимости.
			</p>

			<p className={styles.paragraph}>Подробности можете изучить в роликах:</p>
			<p className={styles.paragraph}>
				{/* Что будет с недвигой после залога */}
				<Video poster='/images/webp/what-will-be.webp' src='/videos/what-will-be.mp4' />
			</p>
			<p className={styles.paragraph}>
				{/* Как работает залоговое кредитование */}
				<Video poster='/images/webp/how-loan-works.webp' src='/videos/how-loan-works.mp4' />
			</p>
			<p className={styles.paragraph}>
				{/* Плюсы и минусы залога */}
				<Video poster='/images/webp/pros-and-cons.webp' src='/videos/pros-and-cons.mp4' />
			</p>

			<h3 id='renter-and-pledge' className={styles.bold}>
				Нужно ли выселять арендаторов из квартиры, чтобы получить кредит?
			</h3>
			<p className={styles.paragraph}>
				У нас нет такого требования. Вы сможете сдавать недвижимость после оформления обременения.
			</p>

			<h3 id='sell-pledged-flat' className={styles.bold}>
				Как продать квартиру, которая находится в залоге?
			</h3>

			<p className={styles.paragraph}>
				Если клиент взял деньги под залог квартиры через Credit.Club, а потом захотел продать
				обременённую недвижимость, мы идём навстречу. После обращения к нам совместно с заёмщиком
				рассматриваем возможные варианты и принимаем решение.
			</p>
			<p className={styles.paragraph}>
				Чаще всего сообщаем клиенту реквизиты, а после поступления денег для погашения долга, сдаём
				заявление на снятие обременения. Объект можно продавать.
			</p>
			<p className={styles.paragraph}>
				<a
					href='https://journal.credit.club/kak-prodat-kvartiru-v-zaloge-4-sposoba'
					target='_blank'
					rel='noopener noreferrer nofollow'
				>
					Больше подробностей о продаже залоговой квартиры:
				</a>
			</p>
			<p className={styles.paragraph}>
				{/* Можно ли продать квартиру в залоге у банка */}
				<Video poster='/images/webp/can-sell.webp' src='/videos/can-sell.mp4' />
			</p>
			<h3 id='loan-and-share-of-real-estate' className={styles.bold}>
				Можно ли взять кредит под залог доли?
			</h3>
			<p className={styles.paragraph}>
				Получить кредит можно, если взять в залог не долю, а объект целиком. В этом случае все
				владельцы станут залогодателями.
			</p>
			<h3 id='pledged-real-estate' className={styles.bold}>
				Можно ли взять кредит, если недвижимость уже в залоге?
			</h3>
			<p className={styles.paragraph}>
				Это возможно, если кредитные деньги пойдут на полное погашение текущих долгов. Чтобы
				провести такую сделку, нужно получить согласие у кредитора на последующий залог.
			</p>
			<h3 id='take-money-without-pledge' className={styles.bold}>
				Нет квартиры в собственности для залога. Что делать, если нужны деньги?
			</h3>

			<p className={styles.paragraph}>
				При получении кредита залогодателем в сделке не обязательно должен быть заёмщик. Им может
				стать кто угодно: друг, родственник, партнёр по бизнесу.
			</p>
			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
				Поэтому если вы уверены в своём доходе и у вас есть человек, который вам доверяет, можете
				обратиться к нему за помощью. Вот какие аргументы можно использовать:
			</p>

			<ul className={styles.list}>
				<li className={styles.item}>— квартира останется в собственности человека;</li>
				<li className={styles.item}>
					— на неё накладывается обременение, которое снимается после выплаты кредита, — не нужно
					ничего переоформлять и выписываться;
				</li>
				<li className={styles.item}>
					— собственник сможет жить в своей квартире, приглашать друзей, делать ремонт или сдавать
					её студентам;
				</li>
				<li className={styles.item}>
					— если сделка оформлена по закону, никто не сможет просто так забрать недвижимость.
				</li>
			</ul>

			<h3 id='application' className={styles.title}>
				Подача заявки
			</h3>

			<h3 id='documents' className={styles.bold}>
				Какие документы нужны для подачи заявки?
			</h3>
			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>Для физических лиц:</p>

			<ol className={styles.orderedList}>
				<li className={styles.orderedItem}>
					Паспорт заёмщика и залогодателя — скан или фото всех страниц.
				</li>
				<li className={styles.orderedItem}>СНИЛС.</li>
				<li className={styles.orderedItem}>Номер телефона и почта.</li>
			</ol>

			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>Для юридических лиц: </p>

			<ol className={styles.orderedList}>
				<li className={styles.orderedItem}>Устав.</li>
				<li className={styles.orderedItem}>Актуальный приказ о назначении директора. </li>
				<li className={styles.orderedItem}>Документы по физлицу (паспорт, СНИЛС).</li>
				<li className={styles.orderedItem}>Номер телефона и почта.</li>
			</ol>

			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
				Для индивидуальных предпринимателей:
			</p>
			<ol className={styles.orderedList}>
				<li className={styles.orderedItem}>Свидетельство ИНН.</li>
				<li className={styles.orderedItem}>Документы по физлицу (паспорт, СНИЛС).</li>
				<li className={styles.orderedItem}>Номер телефона и почта.</li>
			</ol>

			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>Для объекта залога: </p>
			<ol className={styles.orderedList}>
				<li className={styles.orderedItem}>
					Правоустанавливающий документ: договор купли-продажи, договор дарения и т.д.
				</li>
				<li className={cn(styles.orderedItem, styles.lastItem)}>Фотографии дома и квартиры. </li>
			</ol>

			<h3 id='check' className={cn(styles.bold)}>
				Сколько проверяется заявка?
			</h3>
			<p className={cn(styles.paragraph, styles.lastItem)}>
				Обычно заявка проверяется в течение получаса. В некоторых случаях может понадобиться больше
				времени — до 1–2 рабочих дней. Скорость рассмотрения зависит от многих факторов. К примеру,
				чем быстрее мы получаем документы от клиента, тем скорее берём в работу его заявку.
			</p>

			<h3 id='decision' className={cn(styles.bold)}>
				Как узнать решение по заявке?
			</h3>
			<p className={styles.paragraph}>
				Если заявка будет одобрена, менеджер сообщит об этом любым удобным для вас способом: в
				мессенджерах, по почте, телефону. В случае отказа — направит уведомление через СМС и почту.
			</p>
		</article>
	)
}

export default LoanConditions
